// extracted by mini-css-extract-plugin
module.exports = {"container":"_7a3fb80146--container--mJuR1","text":"_7a3fb80146--text--cpY6i"};